export enum AddNumbersRoutes {
  root = 'add-number',
}
